import api from './api';

export const $dg_getNavListNoTips = () => api.getNoTips('/listLv1AndLv2Report');

export const $dg_getNavList = () => api.get('/listLv1AndLv2Report');

export const $dg_getReportDetail = params => api.get('/listReport', params);

export const $dg_getReportRoot = params => api.getNoRejectNoTips('/getReportRight', params);

export const $dg_getPdf = params => api.getNoTips('/getFileBase64', params);

export const $dg_getReportAmount = () => api.get('/getReportAmount');

export const $dg_getSubPdf = params => api.get('/getSubFileBase64', params);

export const $dg_loginOut = params => api.loginGet('', params);

export const $dg_isLogin = () => api.userGetNoTips('/loginController/initLogin');

